import React from 'react';
import { useStatesQuery } from '@uplift/queries';


export const StatesLabel: React.VFC<{
  stateIds: string[];
}> = ({ stateIds }) => {
  const { data: states } = useStatesQuery({ suspense: true });
  const stateNames = stateIds.map((stateId) => states?.find((state) => state.id === stateId)?.fullName).filter(Boolean);

  return (
    <span>
      {stateNames.join(', ') || 'No states found'}
    </span>
  );
};
